import { throttle } from "../../lib";
import DOMHelper from "../../lib/dom-helper";

export default class HeroSection {
	constructor() {
		this.$heroSection = document.querySelector('.section.-hero');
		this.$heroBg = null;

		if (this.$heroSection.classList.contains('-simple')) {
			return;
		}

		this.init();
	}

	init() {
		this.$heroBg = document.querySelector('.section.-hero .hero-bg');
		this.setHeroBgPosition();

		window.addEventListener('scroll', throttle(() => {
			this.setHeroBgPosition();
		}, 20));
	}

	setHeroBgPosition() {
		const windowYPos = window.scrollY;
		const postEntryYPos = DOMHelper.getElementTopPosition(this.$heroSection) + this.$heroSection.offsetHeight;

		if (windowYPos > postEntryYPos + 100) {
			if (!this.$heroBg.classList.contains('pos-absolute')) {
				this.$heroBg.classList.add('pos-absolute');
			}
		} else {
			if (this.$heroBg.classList.contains('pos-absolute')) {
				this.$heroBg.classList.remove('pos-absolute');
			}
		}
	}
}